import { MapPin, Plus, BookOpen } from "lucide-react";

const FAB_ITEMS = [
  { label: "New Journal Note", feature: "The trip journal", Icon: BookOpen, testId: "fab-new-journal" },
  { label: "New Waypoint", feature: "Waypoints", Icon: MapPin, testId: "fab-new-waypoint" },
];

export function MapFABMenu({ fabOpen, setFabOpen, onGetApp }) {
  return (
    <div className="absolute bottom-52 right-2.5 z-10 flex flex-col items-end gap-2" data-testid="fab-container">
      {fabOpen && FAB_ITEMS.map(({ label, feature, Icon, testId }) => (
        <button
          key={testId}
          onClick={() => { setFabOpen(false); onGetApp(feature); }}
          className="flex items-center gap-2.5 bg-gray-900/90 backdrop-blur-sm text-white pl-4 pr-5 py-2.5 rounded-full shadow-lg hover:bg-gray-800 transition-colors animate-in fade-in slide-in-from-bottom-2 duration-200"
          data-testid={testId}
        >
          <Icon className="w-4 h-4" /><span className="text-sm font-semibold whitespace-nowrap">{label}</span>
        </button>
      ))}
      <button
        onClick={() => setFabOpen(prev => !prev)}
        className={`w-[30px] h-[30px] rounded-md shadow-lg flex items-center justify-center bg-orange-500 hover:bg-orange-600 transition-transform duration-200 ${fabOpen ? 'rotate-45' : ''}`}
        data-testid="fab-button"
        aria-label={fabOpen ? "Close add menu" : "Add waypoint or journal note"}
      >
        <Plus className="w-4 h-4 text-white" />
      </button>
    </div>
  );
}
